import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import {
  ICustomQuestionnaire,
  IUpsertCustomQuestionnairePayload
} from 'src/app/pages/setups/models/questionnaire.interface';

@Injectable({
  providedIn: 'root'
})
export class CustomQuestionnaireService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.questionnaire}Custom`;

  constructor(
    private readonly http: HttpClient,
    protected readonly toast: ToastService
  ) {
    super(toast);
  }

  getByCompanyId(companyId: string): Observable<ICustomQuestionnaire[]> {
    return this.http.get<ICustomQuestionnaire[]>(`${this.apiUrl}/company/${companyId}`);
  }

  create(payload: IUpsertCustomQuestionnairePayload): Observable<ICustomQuestionnaire> {
    return this.http.post<ICustomQuestionnaire>(`${this.apiUrl}`, payload);
  }

  update(questionnaireId: string, payload: IUpsertCustomQuestionnairePayload): Observable<ICustomQuestionnaire> {
    return this.http.put<ICustomQuestionnaire>(`${this.apiUrl}/${questionnaireId}`, payload);
  }

  delete(questionnaireId: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${questionnaireId}`);
  }

  getByCategoryId(categoryId: string): Observable<ICustomQuestionnaire[]> {
    return this.http.get<ICustomQuestionnaire[]>(`${this.apiUrl}/category/${categoryId}/all`);
  }
}
